import { Select as SelectPrimitive } from '@base-ui/react/select';

import { cn } from '@/lib/utils';

export type SelectValueProps = SelectPrimitive.Value.Props;

const SelectValue = ({ className, ...props }: SelectValueProps) => {
  return (
    <SelectPrimitive.Value
      data-slot="select-value"
      className={cn('flex flex-1 text-left', className)}
      {...props}
    />
  );
};

export default SelectValue;
